<template>
  <v-container fluid>
    <v-card :loading="loading">
      <v-card-title>
        <h2>
          <v-btn class="mr-2" icon :to="{ name: 'empresas-list' }">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span v-if="loading">Carregando...</span>
          <template v-else>
            <span v-if="form.id === ''">Nova empresa</span>
            <span v-else>Alterar empresa: {{ form.cnpj }}</span>
          </template>
        </h2>
      </v-card-title>
      <form @submit.prevent="submitForm">
        <v-tabs v-model="tabs" grow>
          <v-tab v-if="perms.includes('empresas.editar_dados')">
            <v-icon left color="error" v-if="$v.$invalid" class="mdi mdi-alert-circle"></v-icon>
            <span>Geral</span>
          </v-tab>
          <v-tab v-if="perms.includes('empresas.editar_dados')">
            <v-icon left color="error" v-if="!endereco.valido" class="mdi mdi-alert-circle"></v-icon>
            <span>Endereço</span>
          </v-tab>
          <v-tab>Documentos</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item v-if="perms.includes('empresas.editar_dados')">
            <v-card-text>
              <v-text-field
                v-model="$v.form.cnpj.$model"
                v-touch="form.cnpj"
                v-mask="'cnpj'"
                :error-messages="cnpjErrors"
                maxlength="18"
                label="CNPJ"
              ></v-text-field>
              <v-text-field
                v-model="$v.form.razao_social.$model"
                v-touch="form.razao_social"
                :error-messages="razaoSocialErrors"
                :counter="100"
                label="Razão social"
              ></v-text-field>
              <v-text-field
                v-model="form.nome_fantasia"
                v-touch="form.nome_fantasia"
                :counter="100"
                :error-messages="nomeFantasiaErrors"
                label="Nome fantasia"
              ></v-text-field>
              <v-text-field
                v-model="form.ie"
                v-touch="form.ie"
                :error-messages="ieErrors"
                :counter="15"
                label="Inscrição estadual"
              ></v-text-field>
              <v-text-field
                v-model="form.im"
                v-touch="form.im"
                :error-messages="imErrors"
                :counter="20"
                label="Inscrição municipal"
              ></v-text-field>
              <v-text-field
                v-model="form.crt"
                v-touch="form.crt"
                :error-messages="crtErrors"
                label="Código de regime tributário"
              ></v-text-field>
              <v-switch v-model="form.ativo" label="Empresa ativa" />
              <v-textarea auto-grow v-model="form.observacao" label="Observações" />
            </v-card-text>
          </v-tab-item>
          <v-tab-item v-if="perms.includes('empresas.editar_dados')">
            <v-card-text>
              <endereco-form v-model="endereco" obrigatorio />
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <lista-documentos
              url-base="empresas"
              :id-proprietario="form.id"
              v-model="documentos"
              alterar
            />
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
import ListaDocumentos from "../components/documentos/ListaDocumentos";
import EnderecoForm from "../components/enderecos/EnderecoForm";
import _ from "lodash";

const padrao = {
  id: "",
  razao_social: "",
  nome_fantasia: "",
  cnpj: "",
  ie: "",
  im: "",
  crt: "",
  ativo: true,
  observacao: "",
  id_empresa: ""
};
export default {
  components: { ListaDocumentos, EnderecoForm },
  data() {
    return {
      form: _.clone(padrao),
      loading: false,
      tabs: null,
      documentos: [],
      endereco: {
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        id_cidade: null,
        cep: "",
        cidade: null
      }
    };
  },
  validations: {
    form: {
      razao_social: { required, maxLength: maxLength(100) },
      nome_fantasia: { maxLength: maxLength(100) },
      cnpj: { required, maxLength: maxLength(18) },
      ie: { maxLength: maxLength(15) },
      im: { maxLength: maxLength(20) },
      crt: { required, numeric }
    }
  },
  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
    razaoSocialErrors() {
      const errors = [];
      if (!this.$v.form.razao_social.$dirty) return errors;
      !this.$v.form.razao_social.required &&
        errors.push("Informe a razão social da empresa.");
      !this.$v.form.razao_social.maxLength &&
        errors.push("Somente 100 caracteres.");
      return errors;
    },
    nomeFantasiaErrors() {
      const errors = [];
      if (!this.$v.form.nome_fantasia.$dirty) return errors;
      !this.$v.form.nome_fantasia.maxLength &&
        errors.push("Somente 100 caracteres.");
      return errors;
    },
    cnpjErrors() {
      const errors = [];
      if (!this.$v.form.cnpj.$dirty) return errors;
      !this.$v.form.cnpj.required && errors.push("Informe o CNPJ da empresa.");
      !this.$v.form.cnpj.maxLength && errors.push("Somente 18 caracteres.");
      return errors;
    },
    ieErrors() {
      const errors = [];
      if (!this.$v.form.ie.$dirty) return errors;
      !this.$v.form.ie.maxLength && errors.push("Somente 15 caracteres.");
      return errors;
    },
    imErrors() {
      const errors = [];
      if (!this.$v.form.im.$dirty) return errors;
      !this.$v.form.im.maxLength && errors.push("Somente 20 caracteres.");
      return errors;
    },
    crtErrors() {
      const errors = [];
      if (!this.$v.form.crt.$dirty) return errors;
      !this.$v.form.crt.required && errors.push("Informe o CRT da empresa.");
      !this.$v.form.crt.numeric &&
        errors.push("O CRT deve ser um valor numérico.");
      return errors;
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Grupo Engeguind"
    });

    this.loading = true;

    if (this.$route.params.id) {
      try {
        const response = await this.$store.dispatch(
          "empresa/carregar",
          this.$route.params.id
        );
        this.form = response.data;
        this.endereco = {
          endereco: response.data.endereco,
          numero: response.data.numero,
          complemento: response.data.complemento,
          bairro: response.data.bairro,
          id_cidade: response.data.id_cidade,
          cep: response.data.cep,
          cidade: response.data.cidade,
          valido: true
        };
      } catch (e) {
        console.log(e);
      }
    }

    this.loading = false;
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid && this.endereco.valido) {
        this.loading = true;
        try {
          const empresa = await this.$store.dispatch("empresa/gravar", {
            ...this.form,
            ...this.endereco
          });
          if (this.documentos.length > 0) {
            await this.$store.dispatch("documento/gravar", {
              urlBase: "empresas",
              IDProprietario: empresa.id,
              documentos: this.documentos
            });
          }

          this.$router.replace({ name: "empresas-list" });
          this.loading = false;
        } catch (e) {
          console.log(e);
        }
      }
    }
  }
};
</script>
